"use client";

import { configureAmplifyClient } from "@/lib/amplify/client";

configureAmplifyClient();

export default function ConfigureAmplifyClientSide() {
  return null;
}
